import { Directive } from '@angular/core';

@Directive({
  selector: '[redSelectSearchClear]'
})
export class SelectSearchClearDirective {}
